export const ADD_FUNCTION = 'ADD_FUNCTION'
export const CLEAR_FUNCTION = 'CLEAR_FUNCTION'

export const addFunction = ({ confirmMessage, confirmFunction }) => {
  return dispatch => {
    dispatch({ type: ADD_FUNCTION, confirmMessage, confirmFunction })
  }
}

export const clearFunction = () => {
  return dispatch => {
    dispatch({ type: CLEAR_FUNCTION })
  }
}



// WEBPACK FOOTER //
// ./src/actions/confirm.js